module.exports = __webpack_public_path__ + "img/bubble.e87d7858.svg";